import axios from "axios"
import ApiStore from "./ApiStore";
// var querystring = require('querystring');

export class TyreStore extends ApiStore{
  constructor() {
    super();

  }

  loadReportRepair(year,month,day,searchBy,query,start,length,completeFunc){
    year = year - 543
    axios.get('/tyre/report_repair/all?format=json&year='+year+'&month='+month+'&day='+day+'&q='+query+"&cat="+searchBy+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportRepairRange(start_date,end_date,searchBy,query,start,length,completeFunc){
    axios.get('/tyre/report_repair/all?format=json&start_date='+start_date+'&end_date='+end_date+'&q='+query+"&cat="+searchBy+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportRepairInside(year,month,day,searchBy,query,start,length,completeFunc){
    year = year - 543
    axios.get('/tyre/report_repair_inside/all?format=json&year='+year+'&month='+month+'&day='+day+'&q='+query+"&cat="+searchBy+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportRepairInsideRange(start_date,end_date,searchBy,query,start,length,completeFunc){
    axios.get('/tyre/report_repair_inside/all?format=json&start_date='+start_date+'&end_date='+end_date+'&q='+query+"&cat="+searchBy+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadNewReportRepairDoc(completeFunc){
    axios.get('/tyre/doc_new_repair')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportRepairDoc(trNo,completeFunc){
    axios.get('/tyre/doc_repair/?tyre_repair_no='+trNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadNewReportRepairInsideDoc(completeFunc){
    axios.get('/tyre/doc_new_repair_inside')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportRepairInsideDoc(trNo,completeFunc){
    axios.get('/tyre/doc_repair_inside/?tyre_repair_no='+trNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadSearchTyreSerial(query,completeFunc){
    axios.get('/tyre/search_tyre_serial?q='+query)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }
  
  saveTyreRepairDoc(trNo,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/doc_repair?tyre_repair_no='+trNo,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveTyreRepairInsideDoc(trNo,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/doc_repair_inside?tyre_repair_no='+trNo,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delTyreRepairDoc(trNo,completeFunc,errorFunc){
    axios.delete('/tyre/doc_repair?tyre_repair_no='+trNo)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delTyreRepairInsideDoc(trNo,completeFunc,errorFunc){
    axios.delete('/tyre/doc_repair_inside?tyre_repair_no='+trNo)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  updateTyreRepairDoc(status,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/status_repair/'+status, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  updateTyreRepairInsideDoc(status,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/status_repair_inside/'+status, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadPdfReportRepair(trNo,completeFunc){
    axios.get('/tyre/pdf_repair/?tyre_repair_no='+trNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportRetire(year,month,day,searchBy,query,start,length,completeFunc){
    year = year - 543
    axios.get('/tyre/report_retire/all?format=json&year='+year+'&month='+month+'&day='+day+'&q='+query+"&cat="+searchBy+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportRetireRange(start_date,end_date,searchBy,query,start,length,completeFunc){
    axios.get('/tyre/report_retire/all?format=json&start_date='+start_date+'&end_date='+end_date+'&q='+query+"&cat="+searchBy+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadNewReportRetireDoc(completeFunc){
    axios.get('/tyre/doc_new_retire')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportRetireDoc(trNo,completeFunc){
    axios.get('/tyre/doc_retire/?tyre_retire_no='+trNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveTyreRetireDoc(trNo,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/doc_retire?tyre_retire_no='+trNo,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delTyreRetireDoc(trNo,completeFunc,errorFunc){
    axios.delete('/tyre/doc_retire?tyre_retire_no='+trNo)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  updateTyreRetireDoc(status,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/status_retire/'+status, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadPdfReportRetire(trNo,completeFunc){
    axios.get('/tyre/pdf_retire/?tyre_retire_no='+trNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReportAssetVehicle(completeFunc) {
    axios.get('/tyre/report_asset_vehicle')
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  } 

  loadAssetVehicleTyre(vehicle_id,completeFunc) {
    axios.get('/tyre/asset_vehicle_tyre/'+vehicle_id)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadAssetVehicle(vehicle_id,completeFunc) {
    axios.get('/tyre/asset_vehicle/'+vehicle_id)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveAssetVehicleTyre(vehicle_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    let url = '/tyre/asset_vehicle'
    if (vehicle_id!=='')
      url = '/tyre/asset_vehicle/'+vehicle_id
    axios.post(url, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveAssetVehicleSwap(vehicle_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/asset_vehicle_swap/'+vehicle_id, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveAssetVehicleReplace(vehicle_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/asset_vehicle_replace/'+vehicle_id, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveAssetVehicleRepair(vehicle_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/asset_vehicle_repair/'+vehicle_id, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadAssetVehicleSwap(vehicle_id,position,completeFunc) {
    axios.get('/tyre/asset_vehicle_swap/'+vehicle_id+'/'+position)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadAssetVehicleReplace(vehicle_id,position,completeFunc) {
    axios.get('/tyre/asset_vehicle_replace/'+vehicle_id+'/'+position)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadAssetVehicleHistory(type,rId,completeFunc) {
    axios.get('tyre/asset_vehicle_record/'+type+'/form/'+rId)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  delAssetVehicle(vehicle_id,completeFunc,errorFunc){
    axios.delete('/tyre/asset_vehicle/'+vehicle_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadAssetVehicleRecord(type,vehicle_id,completeFunc) {
    axios.get('/tyre/asset_vehicle_record/'+type+'/'+vehicle_id)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadAssetVehicleRecordByType(type,vehicle_id,at,completeFunc) {
    axios.get('/tyre/asset_vehicle_record/'+type+'/'+vehicle_id+'/'+at)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveAssetVehicleTreadDepth(vehicle_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/asset_vehicle_treaddepth/'+vehicle_id, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveImportStockTyre(stock_type,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/tyre/import_stock_tyre/'+stock_type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

}  

export default new TyreStore()


// WEBPACK FOOTER //
// ./src/stores/TyreStore.js